import { render, staticRenderFns } from "./AddPromoSelectionProducts.vue?vue&type=template&id=2818cd93"
import script from "./AddPromoSelectionProducts.vue?vue&type=script&lang=js"
export * from "./AddPromoSelectionProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports